import { COMPANY_REQUEST, CREATE_COMPANY, UPDATE_COMPANY, GET_COMPANIES, COMPANY_REQUEST_FAILURE, SET_USER_AUTHORIZE_COMPANIES, DELETE_COMPANY, SUCCESS_COMPANY } from '../types';

const initialState = {
  companies: [],
  authUserCompanies: [],
  loading: false,
  error: null,
};

const companyReducer = (state = initialState, action) => {
  switch (action.type) {
    case COMPANY_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null
      }
    }
    case GET_COMPANIES: {
      return {
        ...state,
        companies: [...action.payload],
        loading: false,
        error: null
      }
    }
    case SET_USER_AUTHORIZE_COMPANIES:
      return {
        ...state,
        authUserCompanies: action.payload,
        loading: false,
        error: null
      };
    case CREATE_COMPANY:
      return {
        ...state,
        companies: [action.payload, ...state.companies],
        loading: false,
        error: null
      };
    case UPDATE_COMPANY:
      const companiesData = state.companies.slice(0);
      const uIndex = companiesData.findIndex((data) => data.id === action.payload.id);
      companiesData.splice(uIndex, 1, { ...action.payload.data });
      return {
        ...state,
        companies: [ ...companiesData ],
        loading: false,
        error: null
      };
    case COMPANY_REQUEST_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error
      }
    }
    case SUCCESS_COMPANY: {
      return {
        ...state,
        loading: false,
        error: action.error
      }
    }
    case DELETE_COMPANY:
      const companies = state.companies?.slice(0);
      const index = companies.findIndex((data) => data.id === action.id);
      if (index > -1) {
        companies.splice(index, 1);
      }
      return {
        ...state,
        companies: [...companies],
        loading: false,
        error: null
      }
    default:
      return state;
  }
};

export default companyReducer;
